import { render, staticRenderFns } from "./DeptMcnBonusView.vue?vue&type=template&id=1ca624f4&scoped=true"
import script from "./DeptMcnBonusView.vue?vue&type=script&lang=js"
export * from "./DeptMcnBonusView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca624f4",
  null
  
)

export default component.exports